import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import CurrencySymbol from 'components/common/currency-symbol';

import { Fee } from 'models/fees';
import { Location } from 'models/locations';

const propTypes = {
  category: PropTypes.string.isRequired,
  fees: PropTypes.arrayOf(PropTypes.instanceOf(Fee)).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  showModal:  PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

class FeesBreakdownModal extends Component {  
  renderPrice(price) {
    const { location } = this.props;
    const prefix = Number(price) < 0 ? '-' : '';

    return (
      <span>
        {prefix}
        <CurrencySymbol location={location} />
        {Math.abs(price).toFixed(2)}
      </span>
    );
  }

  renderBreakdown() {
    const { fees } = this.props;
    const elements = [];
    
    const displayDetails = fees.length > 1;
    fees.forEach((fee) => {   
      if (displayDetails) {
        elements.push(
          <div className="row padding-bottom-sm-20" key={fee.label}>
            <div className="col-xs-6 text-align-left text-color-dark-slate">
              { fee.label }
            </div>
            <div className="col-xs-6 text-align-right text-color-dark-slate padding-bottom-sm-10">
              { this.renderPrice(fee.price) }
            </div>
            <div className="col-xs-12 text-align-left text-weight-book">
              { fee.description }
            </div>
          </div>,
        );
      } else {
        elements.push(
          <div className="row padding-bottom-sm-20" key={fee.label}>
            <div className="col-xs-12 text-align-center text-weight-book">
              { fee.description }
            </div>
          </div>
        );
      }
    });

    return elements;
  }

  render() {
    const { showModal, closeModal } = this.props;

    return (  
      <Modal className="notices-modal fees-modal checkout-modal" show={showModal} onHide={closeModal}> 
        <div className="fees-modal-header padding-bottom-xs-10 padding-bottom-sm-20 text-weight-black text-size-sm-24 text-size-xs-18 text-color-dark-slate">
          <div
            className="fees-modal-close padding-right-30 float-right iconified-font iconified-x text-size-18 text-color-dark-slate text-color-hover-blue clickable"
            onClick={closeModal}
            type="button"
          />
        </div>
        <Modal.Body>
          {this.renderBreakdown()}
        </Modal.Body>
      </Modal>
    );
  }
}

FeesBreakdownModal.propTypes = propTypes;

export default FeesBreakdownModal;

